import { ConfirmationModal } from '@unbounded/unbounded-components'

export const AVAILABLE_DIALOGS = {
  ConfirmationModal,
}
